import { useEffect, useState } from "react";
import { getConfig, saveConfig } from "../../lib/data";
import { formatCLP } from "../../lib/format";
import type { ConfigGeneral } from "../../lib/types";
import { Spinner } from "../../components/ui";

export function Configuracion() {
  const [cfg, setCfg] = useState<ConfigGeneral | null>(null);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    (async () => {
      try { setCfg(await getConfig()); } finally { setLoading(false); }
    })();
  }, []);

  async function guardar() {
    if (!cfg) return;
    setMsg("");
    try { await saveConfig(cfg); setMsg("✓ Configuración guardada"); }
    catch (e) { setMsg((e as Error).message); }
  }

  if (loading || !cfg) return <Spinner />;

  const set = (patch: Partial<ConfigGeneral>) => setCfg({ ...cfg, ...patch });
  const setPractica = (i: number, patch: Partial<ConfigGeneral["practicas"][number]>) => {
    const practicas = cfg.practicas.map((p, idx) => (idx === i ? { ...p, ...patch } : p));
    setCfg({ ...cfg, practicas });
  };

  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold text-slate-800">Configuración</h1>
        <p className="text-sm text-slate-500">Parámetros generales de la academia</p>
      </div>

      <section className="card space-y-4 p-5">
        <h2 className="font-bold text-slate-700">General</h2>
        <div className="grid gap-4 sm:grid-cols-2">
          <div><label className="label">Nombre de la academia</label><input className="input" value={cfg.nombreAcademia} onChange={(e) => set({ nombreAcademia: e.target.value })} /></div>
          <div><label className="label">Año lectivo</label><input className="input" type="number" value={cfg.anoLectivo} onChange={(e) => set({ anoLectivo: Number(e.target.value) })} /></div>
          <div><label className="label">Correo administrador</label><input className="input" value={cfg.emailAdmin} onChange={(e) => set({ emailAdmin: e.target.value })} /></div>
          <div><label className="label">Meses de desfase</label><input className="input" type="number" value={cfg.mesesDesfase} onChange={(e) => set({ mesesDesfase: Number(e.target.value) })} /></div>
        </div>
      </section>

      <section className="card space-y-4 p-5">
        <h2 className="font-bold text-slate-700">Reglas de cobro</h2>
        <div className="grid gap-4 sm:grid-cols-3">
          <div><label className="label">Interés mora (%)</label><input className="input" type="number" value={cfg.interesMoraPct} onChange={(e) => set({ interesMoraPct: Number(e.target.value) })} /></div>
          <div><label className="label">Días de gracia</label><input className="input" type="number" value={cfg.diasGracia} onChange={(e) => set({ diasGracia: Number(e.target.value) })} /></div>
          <div><label className="label">Descuento hermanos (%)</label><input className="input" type="number" value={cfg.descuentoHermanosPct} onChange={(e) => set({ descuentoHermanosPct: Number(e.target.value) })} /></div>
        </div>
      </section>

      <section className="card space-y-4 p-5">
        <h2 className="font-bold text-slate-700">Prácticas deportivas</h2>
        {cfg.practicas.map((p, i) => (
          <div key={p.clave} className="rounded-xl border border-slate-100 p-4">
            <p className="mb-3 font-semibold">{p.nombre}</p>
            <div className="grid gap-3 sm:grid-cols-3">
              <div>
                <label className="label">Valor cuota</label>
                <input className="input" type="number" value={p.valorCuota} onChange={(e) => setPractica(i, { valorCuota: Number(e.target.value) })} />
                <p className="mt-1 text-xs text-slate-400">{formatCLP(p.valorCuota)}</p>
              </div>
              <div><label className="label">Día vencimiento</label><input className="input" type="number" value={p.diaVencimiento} onChange={(e) => setPractica(i, { diaVencimiento: Number(e.target.value) })} /></div>
              <div><label className="label">Cuenta de pago</label><input className="input" value={p.cuenta} onChange={(e) => setPractica(i, { cuenta: e.target.value })} /></div>
            </div>
          </div>
        ))}
      </section>

      <div className="flex items-center gap-3">
        <button className="btn-primary" onClick={guardar}>Guardar cambios</button>
        {msg && <span className="text-sm text-emerald-600">{msg}</span>}
      </div>
    </div>
  );
}
